<template>

    <div class="pa-2">
        <div class="text-center" v-show="loadingOverlay">
            <v-progress-circular
                    :width="3"
                    color="blue"
                    indeterminate="">
            </v-progress-circular>
        </div>
        <div v-show="!loadingOverlay">
            <v-treeview
                    :items="applications"
                    :open-all="true"
                    item-children="children"
                    item-text="name"
                    :selectable="true"
                    v-model="orgApps"
                    item-key="id"></v-treeview>
            <v-btn outlined type="button" @click="save()" color="success">Save</v-btn>
        </div>
    </div>

</template>

<script>

    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'

    export default {
        inject : ['getProvidedOrganization'],
        mixins:[validationMixin],
        data() {
            return {
                applications : [],
                orgApps : [],
                loadingOverlay : true
            }
        },
        mounted() {
            this.organization = this.getProvidedOrganization();
            this.get();
        },
        methods : {
            get() {
                this.loadingOverlay = true;
                api.organization.application.get(this.organization.id).then(orgApps => {
                    api.application.search().then(apps => {
                        let selApps = [];
                        apps.forEach((app) => {
                            app.children = [];
                            let has = false;
                            orgApps.forEach((oa) => {
                                if (oa.id == app.id) {
                                    has = true;
                                }
                            });
                            if (has) {
                                selApps.push(app.id);
                            }
                        });
                        this.orgApps = selApps;
                        this.applications = apps;
                        this.loadingOverlay = false;
                    });

                });
            },
            save() {
                api.organization.application.post(this.organization.id,this.orgApps).then(() => {
                    this.$root.$emit('globalMessage','Organization Applications Updated');
                    // emit to parent that organizations were updated.  This is so it can reload menu options
                    this.$parent.$emit('applicationsUpdated');
                    this.get();
                },(error) => {
                    this.processErrors(error);
                });
            }
        }
    }

</script>